export const glossary = [
  {
    term: "Material Deck (Deck de Material)",
    category: "Regras de Deck",
    definition: "Deck composto exclusivamente por cartas de Campeão (Champion) e Regalia (Regalia), identificáveis pelo custo Azul (Memory Cost). Possui limite máximo de 12 cartas no total e é estritamente singleton (máximo de 1 cópia de cada carta por nome). É obrigatório conter ao menos 1 Campeão de Nível 0 (Level 0 Champion) para iniciar a partida. O jogador pode olhar o conteúdo do seu Material Deck a qualquer momento e a ordem das cartas não importa."
  },
  {
    term: "Main Deck (Deck Principal)",
    category: "Regras de Deck",
    definition: "Deck principal composto pelas cartas que você compra para a sua mão durante a partida (Aliados/Ally, Ações/Action, Ataques/Attack, etc.), identificáveis pelo custo Amarelo (Reserve Cost). Possui tamanho mínimo de 60 cartas e limite de até 4 cópias de cada carta por nome. Cartas de Campeão e Regalia NÃO podem estar no Main Deck. Ao contrário do Material Deck, você não pode olhar livremente nem reorganizar as cartas do Main Deck."
  },
  {
    term: "Champion (Campeão)",
    category: "Tipos de Cartas",
    definition: "Cartas de personagem que representam o jogador na mesa e definem a linhagem, elementos e níveis durante a partida. Devem pertencer exclusivamente ao Material Deck e possuem custo Azul (Memory). É obrigatório ter pelo menos 1 Campeão de Nível 0 no Material Deck para o início de jogo."
  },
  {
    term: "Regalia",
    category: "Tipos de Cartas",
    definition: "Itens, armas e relíquias ancestrais que podem ser materializadas diretamente do Material Deck para equipar ou conceder habilidades ao seu Campeão. Exclusivas do Material Deck e possuem custo Azul (Memory)."
  },
  {
    term: "Memory Cost (Custo Azul)",
    category: "Custos & Recursos",
    definition: "Custo com ícone/borda azul que indica que a carta pertence exclusivamente ao Material Deck (Campeões e Regalias). É pago utilizando cartas de Memory geradas ao longo da partida."
  },
  {
    term: "Reserve Cost (Custo Amarelo)",
    category: "Custos & Recursos",
    definition: "Custo com ícone/borda amarela que indica que a carta pertence ao Main Deck (Aliados, Ações, Ataques, etc.). É pago alocando cartas da sua mão ou reservas."
  },
  {
    term: "Level 0 Champion (Campeão Nível 0)",
    category: "Regras de Deck",
    definition: "O Campeão inicial obrigatório que deve estar presente no seu Material Deck (pelo menos 1 cópia). Ele é colocado em campo no início do jogo para dar início à partida."
  },
  {
    term: "Materializar (Materialize)",
    category: "Mecânica",
    definition: "Ação de jogo que permite ao jogador revelar e colocar em campo uma carta do seu Material Deck (Campeão ou Regalia) pagando o seu custo Azul (Memory Cost) na fase apropriada."
  },
  {
    term: "Ally (Aliado)",
    category: "Tipos de Cartas",
    definition: "Criaturas e companheiros que pertencem ao Main Deck (custo Amarelo/Reserve) e podem ser invocados em campo para atacar, defender e fornecer efeitos táticos ao lado do seu Campeão."
  },
  {
    term: "Attack (Ataque)",
    category: "Tipos de Cartas",
    definition: "Cartas de combate do Main Deck jogadas da mão para executar golpes físicos ou mágicos contra alvos do oponente, ativando sequências de combate."
  },
  {
    term: "Action (Ação)",
    category: "Tipos de Cartas",
    definition: "Mágicas e táticas de efeito rápido ou padrão jogadas do Main Deck a partir da mão para alterar o estado de jogo, comprar cartas ou interagir com oponentes."
  },
  {
    term: "Item / Equipamento",
    category: "Tipos de Cartas",
    definition: "Cartas de suporte e utilidades que concedem bônus ou habilidades permanentes enquanto estiverem em campo."
  }
];

export const faq = [
  {
    q: "Quantos decks cada jogador traz para uma partida de Grand Archive?",
    a: "Cada jogador traz exatamente dois decks: o Material Deck (composto por até 12 cartas de Campeões e Regalias) e o Main Deck (composto por no mínimo 60 cartas com até 4 cópias de cada)."
  },
  {
    q: "Quais são as regras de construção do Material Deck?",
    a: "O Material Deck deve ter no máximo 12 cartas no total, pode conter no máximo 1 cópia de cada carta por nome (singleton), e deve ter obrigatoriamente pelo menos 1 Campeão de Nível 0. Apenas cartas dos tipos Champion e Regalia (custo Azul/Memory) são permitidas."
  },
  {
    q: "Quais são as regras de construção do Main Deck?",
    a: "O Main Deck deve ter no mínimo 60 cartas, permitindo até 4 cópias de cada carta por nome. Ele é composto por cartas como Aliados (Ally), Ações (Action), Ataques (Attack) e outros tipos com custo Amarelo (Reserve). Cartas de Campeão e Regalia NÃO podem estar no Main Deck."
  },
  {
    q: "Posso olhar o conteúdo dos meus decks durante a partida?",
    a: "Sim, você pode olhar o conteúdo do seu próprio Material Deck a qualquer momento (ele permanece oculto para os oponentes e a ordem das cartas não importa). Por outro lado, você NÃO pode olhar livremente nem reorganizar o conteúdo do seu Main Deck."
  },
  {
    q: "Como saber rapidamente em qual deck uma carta pertence?",
    a: "Olhe para a cor do custo da carta: se o custo for Azul (Memory Cost), a carta pertence ao Material Deck (Champion/Regalia). Se o custo for Amarelo (Reserve Cost), a carta pertence ao Main Deck (Ally, Action, Attack, etc.)."
  }
];
